// test1112
(1112 && 0);
